import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { OrganizationService } from 'src/app/services/organization.service';
import { first, timeout } from 'rxjs/operators';
import { WebConstants } from '../../../util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { LprDataService } from 'src/app/services/lpr-data.service';
import { UserService } from 'src/app/services/user.service';
import { GeofenceService } from 'src/app/services/geofence.service';
import { BaseChartDirective } from 'ng2-charts';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { AnalyticsService } from 'src/app/services/analytics.service';
import { TokenStorage } from 'src/app/util/token.storage';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import * as Chart from 'chart.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { ConfigurationService } from 'src/app/services/configuration.service';


@Component({
  selector: 'app-dashboard-organization',
  templateUrl: './dashboard-organization.component.html',
  styleUrls: ['./dashboard-organization.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class DashboardOrganizationComponent implements OnInit {

  constructor(public organizationService: OrganizationService,
    public toastrService: ToastrService,
    public lprdataservice: LprDataService,
    public excelExportDataService: ExcelExportDataService,
    public authenticationService: AuthenticationService,
    public tokenStorage: TokenStorage,
    public analyticsService: AnalyticsService,
    public userService: UserService,
    public geofenceService: GeofenceService,
    public datePipe: DatePipe,
    public configurationService: ConfigurationService) { }

    public title: string = WebConstants.MENU_NAMES.DASHBOARD;
    public userRole: any;

    @ViewChild('liveSectionCanvas') liveSectionCanvas: ElementRef;
    @ViewChild('vehicleLocationMapCanvas') vehicleLocationMapCanvas: ElementRef;
    @ViewChild('violationTrendsCanvas') violationTrendsCanvas: ElementRef;
    @ViewChild('violationInsightsCanvas') violationInsightsCanvas: ElementRef;
    @ViewChild('hotspotZoneScansCanvas') hotspotZoneScansCanvas: ElementRef;
    @ViewChild('hotspotZoneViolationsCanvas') hotspotZoneViolationsCanvas: ElementRef;
    @ViewChild('scannedViolationByPeoCanvas') scannedViolationByPeoCanvas: ElementRef;
    @ViewChild('scannedViolationByZoneCanvas') scannedViolationByZoneCanvas: ElementRef;
    public selectedDivElemetRef: any;

    @ViewChild('canvas') canvas: ElementRef;
    @ViewChild('downloadLink') downloadLink: ElementRef;


    markerIcon = {
      url: 'assets/images/peo_marker.png',
      scaledSize: {
        width: 50,
        height: 70
      }
    }

    //Current Date
    currentDateEpoch = new Date();
    currentDateRegular = this.getDateWithFormat(this.currentDateEpoch, WebConstants.DATE.FORMAT_MM_DD_YYYY);


    //Chart
    @ViewChild(BaseChartDirective)
    public chart: BaseChartDirective;


    // Date Filters
    public selectedDateDay: {start, end} = {start:moment().subtract(0, 'days'), end:moment()};
    public selectedDateWeek: {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
    public selectedDateMonth: {start, end} = {start:moment().subtract(31, 'days'), end:moment()};
    public selectedDateCustom: {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
    public selectedDateFilter: any = this.selectedDateDay;
    public selectedTabIndex: any = 0;
    // public selectedTabIndexTrafficMap: any = 0;


    //Default Location
    defaultLocation: any = {
      latitude: 67.05245263869374,
      longitude: 24.85995977760333
    }


    // Map Tab
    heatmapSelectedRowIndex: number = -1;
    // trafficFlowMapTabList: any = [];
    // selectedTrafficFlowMapTabData: any = [];


    // Violation Circle Progress Bar
    zoneProgressPercentage: any = [];

    defaultCircleProgressOptions = {
      maxPercent: 100,
      radius:60,
      outerStrokeWidth:30,
      innerStrokeWidth:25,
      outerStrokeColor:'goldenrod',
      innerStrokeColor:'DimGray',
      animation:true,
      animationDuration:300,
      showUnits: true,
      titleFontSize:30,
      unitsFontSize:20,
      space:-26,
      showSubtitle: false,
      outerStrokeLinecap:'butt',
      titleColor: '#FFFFFF',
      unitsColor: '#FFFFFF'
    }

    carList: string[] = [
      'C7',
      'C8',
      'C9'
    ];


    //Bar Charts
    liveSectionBarChart: any;
    liveSectionBarChartData: any = [];

    violationSectionBarChart: any;
    violationSectionBarChartData: any = [];
    violationSectionLineChartData: any = [];
    countViolationForHourly: any = [];

    peoSectionBarChart: any;
    peoSectionBarChartData: any = [];

    revenueSectionZoneBarChart: any;
    revenueSectionZoneBarChartData: any = [];

    revenueSectionAnalyticsBarChart: any;
    revenueSectionAnalyticsBarChartData: any = [];

    barThickness: any = 50;
    barBackgroundColor: any = 'rgba(218, 165, 32, 1)';



    // Violations Line Chart
    public chartLine: any;


    // Violations Progress bars
    public unauthProgressBar: any = '100%';
    public unpaidProgressBar: any = '55%';
    public expiredProgressBar: any = '15%';


    // PEO Shift Progress bars
    public peoSectionProgressBar = [];


    // PEO Last Location
    public peoLastLocationData: any = [];
    public selectedPeoLocation: any = {
      latitude: 0,
      longitude:0
    };
    public selectedPeoIndex: any = 0;


    //Revenue
    revenuePrice: any = 0;
    revenueViolationData: any;
    revenueMonthlyViolationData: any;
    violationTotalRevenue: any = 0;
    ticketPriceData: any = [];

    //AGM MAP
    infoOpen = false;
    showTrafficFlowMap = false;
    private map: google.maps.Map | null = null;
    private heatmap: google.maps.visualization.HeatmapLayer | null = null;


    //PEO Users
    peoUsersData: any = [];
    selectedPeoId: any = null;

    //Geofence Data
    shiftDetailsData: any = [];
    allGeofenceData: any = [];
    selectedGeofenceId: any = null;
    selectedGeofenceShiftDetails: any = [];
    violationDataMonthly: any = [];


    //Export Data
    currentOrgId: any
    currentOrgData: any
    dataForExport: any
    analyticsType: any;
    headerForExport = [];
    dataForCsvPdf = [];
    dateRangeForExport: any;


    //Parallel Data Check
    violationDataCheck: any = false;
    shiftDetailsCheck: any = false;


    ngOnInit() {
      console.log("Dashboard Organization")
      this.currentOrgId = this.tokenStorage.getOrganizationId();
      this.userRole = this.tokenStorage.getRole();

      this.getAllTicketPrice();
      this.getOrganizationDetailById();
      this.getAllPeoUsers();
      this.getAllGeofences();
      // this.getAllShiftDetails();

      setTimeout(() => {
        this.getLiveSectionStatistics();
        this.getAllDataMethods();
        this.getPeoLastLocation();
      }, 1000);
    }



    getAllTicketPrice() {
      this.configurationService.getAllTicketPrice()
        .pipe(first())
        .subscribe(response => {
          if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.ticketPriceData = response.data;
            this.revenuePrice = this.ticketPriceData[0]? this.ticketPriceData[0].amount : 0
          }
          else {
            this.toastrService.error(response.value, "Failed To Load Data!");
          }
        });
    }




    checkParallelData(){
      if(this.violationDataCheck && this.shiftDetailsCheck && this.shiftDetailsData.length > 0 && this.violationSectionBarChartData.data.length > 0){
        // this.selectedTabIndexTrafficMap = 1;
        const lastObj = this.shiftDetailsData.length - 1;
        this.onRowClicked(this.shiftDetailsData[lastObj], this.shiftDetailsData[lastObj].geofenceId);
        // this.onMapLoad(this.map);
      }
    }

    onTabChanged(event: any){
      this.selectedTabIndex = event.index;

      if(this.selectedTabIndex == 0){
        this.selectedDateFilter = this.selectedDateDay;
      }
      else if(this.selectedTabIndex == 1){
        this.selectedDateFilter = this.selectedDateWeek;
      }
      else if(this.selectedTabIndex == 2){
        this.selectedDateFilter = this.selectedDateMonth;
      }
      else if(this.selectedTabIndex == 3){
        this.selectedDateFilter = this.selectedDateCustom;
        return;
      }

      this.getAllDataMethods();
    }

    onChangeDateRange(event: any){
      if(event.start && event.start){
        this.selectedDateFilter = this.selectedDateCustom;
        this.getAllDataMethods();
      }
    }

    onPeoMapTabChanged(event: any){
      this.selectedPeoIndex = event.index;
      this.selectedPeoLocation = {latitude: 0, longitude: 0};

      setTimeout(() => {
        if(this.selectedPeoIndex != 0){
          this.selectedPeoLocation = this.peoLastLocationData[this.selectedPeoIndex - 1];
        }
        else{
          this.selectedPeoLocation = this.peoLastLocationData[0];
        }
      }, 100);
    }

    onPeoMapTabClicked(){
      let event: any = {index: this.selectedPeoIndex}
      this.onPeoMapTabChanged(event);
    }

    // onTrafficFlowMapTabChanged(event: any){
    //   if(event.index == 0)
    //   {
    //     return;
    //   }

    //   this.selectedTrafficFlowMapTabData = this.trafficFlowMapTabList[event.index - 1];
    //   this.filterShiftDataByGeofence(this.selectedTrafficFlowMapTabData.geofenceId);
    // }

    getOrganizationDetailById(){
      this.organizationService.getOrganizationDetailById(this.currentOrgId)
        .pipe(first())
        .subscribe(response => {
          if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.currentOrgData = response.data;
          }
        });
    }

    getAllPeoUsers(){
      this.userService.getAllCommon()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.peoUsersData = response.data.filter(x=>x.roleName == "Patrolling Officer");
        }
      });
    }

    getAllGeofences(){
      this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allGeofenceData = response.data;
        }
      });
    }

    onChangePeoId(peoId: any){
      this.selectedPeoId = peoId;
    }

    onChangeGeofenceId(geofenceId: any){
      this.selectedGeofenceId = geofenceId;
    }

    getAllDataMethods(){
      this.getViolationSectionStatistics();
      this.getPeoShiftSectionStatistics();
      this.getStatisticsMonthly();
      this.getAllShiftDetails();
    }

    getPeoLastLocation(){
      let payload = {
        "orgId": this.currentOrgId
      }

      this.analyticsService.getPeoLastLocation(payload).pipe(first()).subscribe(response => {
        this.peoLastLocationData = response.data;
        this.selectedPeoLocation = this.peoLastLocationData[0];
      })
    }

    getAllShiftDetails(){
      this.shiftDetailsCheck = false;
      // this.selectedTabIndexTrafficMap = 0;

      let payload = {
        "startTime": this.selectedDateFilter.start.format("MM-DD-YYYY"),
        "endTime": this.selectedDateFilter.end.format("MM-DD-YYYY"),
        "orgId": this.currentOrgId,
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId
      }

      this.analyticsService.getAllLprLocationAndGeofence(payload).pipe(first()).subscribe(response => {
        if(response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.shiftDetailsData = response.data;
          this.shiftDetailsCheck = true;

          this.checkParallelData();
        }
      });
    }

    filterShiftDataByGeofence(geofenceId: any){
      this.selectedGeofenceShiftDetails = [];

      if(this.shiftDetailsData && this.shiftDetailsData.length > 0){
        this.shiftDetailsData.forEach(record => {
          if(record.geofenceId == geofenceId && (record.matchedStatus == 'Expired' || record.matchedStatus == 'Unpaid' || record.matchedStatus == 'Unauthorized')){
            this.selectedGeofenceShiftDetails.push(record);
          }
        });
      }

      if(this.selectedGeofenceShiftDetails && this.selectedGeofenceShiftDetails.length > 0){
        this.defaultLocation.latitude = this.selectedGeofenceShiftDetails[0].latitude;
        this.defaultLocation.longitude = this.selectedGeofenceShiftDetails[0].longitude;
      }

      this.onMapLoad(this.map);
    }

    getLiveSectionStatistics(){
      this.findCurrentOrganizationDataDaily({
        "startTime": this.currentDateRegular,
        "endTime": this.currentDateRegular,
        "orgId": this.currentOrgId,
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId
      });
    }

    findCurrentOrganizationDataDaily(payload): void {
      this.lprdataservice.ShiftStatsDataDaily(payload)
      .pipe(first())
      .subscribe(response => {
        if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
          this.liveSectionBarChartData = response.data[0];
          this.createLiveSectionBarChart();
        }
         else{
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      })
    }

    getViolationSectionStatistics(){
      this.findViolationDataForLineChart({
        "startTime": this.selectedDateFilter.start.format("MM-DD-YYYY"),
        "endTime": this.selectedDateFilter.end.format("MM-DD-YYYY"),
        "orgId": this.currentOrgId,
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId
      });

      this.findViolationDataForOthers({
        "startTime": this.selectedDateFilter.start.format("MM-DD-YYYY") + " 00:00:00",
        "endTime"  : this.selectedDateFilter.end.format("MM-DD-YYYY") + " 23:59:59",
        "orgId": this.currentOrgId,
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId
      });
    }


    findViolationDataForLineChart(payload: any){

      if(this.selectedTabIndex == 0){
        this.analyticsService.getAllLprLocationAndGeofence(payload).pipe(first()).subscribe(response => {
          if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
            this.violationSectionLineChartData = response.data;

            this.countViolationForHourly = new Array(24).fill(0);
            for (let i = 0; i < this.violationSectionLineChartData.length; i++) {
              let hour = new Date(this.violationSectionLineChartData[i].createdDate).getHours();
              let rowStatus = this.violationSectionLineChartData[i].matchedStatus;

              if(rowStatus == "Expired" || rowStatus == "Unauthorized" || rowStatus == "Unpaid"){
                this.countViolationForHourly[hour]++;
              }
            }

            this.createViolationSectionLineChart();
          }
           else{
            this.toastrService.error(response.value, "Failed To Load Data!")
          }
        })
      }
      else if(this.selectedTabIndex == 1){
        this.lprdataservice.ShiftStatsDataDaily(payload).pipe(first()).subscribe(response => {
          if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
            this.violationSectionLineChartData = response.data;
            this.createViolationSectionLineChart();
          }
           else{
            this.toastrService.error(response.value, "Failed To Load Data!")
          }
        })
      }
      else if(this.selectedTabIndex == 2 || this.selectedTabIndex == 3){
        this.lprdataservice.ShiftStatsDataMonthly(payload).pipe(first()).subscribe(response => {
          if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
            this.violationSectionLineChartData = response.data;
            this.createViolationSectionLineChart();
          }
           else{
            this.toastrService.error(response.value, "Failed To Load Data!")
          }
        })
      }
    }


    findViolationDataForOthers(payload: any){

      this.violationDataCheck = false;

      this.analyticsService.getViolationAnalyticsByAllGeofence(payload)
      .pipe(first())
      .subscribe(response => {
        if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
          this.violationSectionBarChartData = response.data;
          this.violationDataCheck = true;

          // Sorting in Descending Order on Basis of Value of Field;
          this.violationSectionBarChartData.data.sort((a,b) => (a.violationCount < b.violationCount) ? 1 : ((b.violationCount < a.violationCount) ? -1 : 0))

          let unpaidPercentage = parseFloat(((this.violationSectionBarChartData.totalUnpaid/this.violationSectionBarChartData.totalViolation)*100).toString()).toFixed(2);
          let unauthPercentage = parseFloat(((this.violationSectionBarChartData.totalUnauthorized/this.violationSectionBarChartData.totalViolation)*100).toString()).toFixed(2);
          let expiredPercentage = parseFloat(((this.violationSectionBarChartData.totalExpired/this.violationSectionBarChartData.totalViolation)*100).toString()).toFixed(2);

          this.unpaidProgressBar  = unpaidPercentage != "NaN"? unpaidPercentage + "%" : "0%";
          this.unauthProgressBar  = unauthPercentage != "NaN"? unauthPercentage  + "%" : "0%";
          this.expiredProgressBar = expiredPercentage != "NaN"? expiredPercentage  + "%" : "0%";

          // this.setViolationHeatMapTabText();
          // this.getAllShiftDetails();

          this.createViolationSectionBarChart();
          this.createPeoSectionBarChart();
          this.createViolationSectionCircleProgress();
          this.createRevenueSectionZoneBarChart();

          this.checkParallelData();
        }
         else{
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      })
    }

    getStatisticsMonthly(){
      this.findCurrentOrganizationDataMonthly({
        "startTime": this.selectedDateFilter.start.format("MM-DD-YYYY"),
        "endTime": this.selectedDateFilter.end.format("MM-DD-YYYY"),
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId,
        "orgId": this.currentOrgId
      });
    }

    findCurrentOrganizationDataMonthly(payload): void {
      this.lprdataservice.ShiftStatsDataMonthly(payload)
      .pipe(first())
      .subscribe(response => {
        if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
          this.violationDataMonthly = response.data;
          this.createRevenueSectionAnalyticsBarChart();
        }
         else{
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      })
    }

    getPeoShiftSectionStatistics(){
      this.findPeoShiftData({
        "startTime": this.selectedDateFilter.start.format("MM-DD-YYYY"),
        "endTime"  : this.selectedDateFilter.end.format("MM-DD-YYYY"),
        "peoId": this.selectedPeoId,
        "geofenceId": this.selectedGeofenceId,
        "orgId"    : this.currentOrgId
      });
    }


    findPeoShiftData(payload: any){
      this.analyticsService.getViolationAnalyticsByAllPeo(payload)
      .pipe(first())
      .subscribe(response => {
        if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
          this.peoSectionBarChartData = response.data;
          this.peoSectionBarChartData.sort((a,b) => (a.violationCount < b.violationCount) ? 1 : ((b.violationCount < a.violationCount) ? -1 : 0))
          this.peoSectionProgressBar = [];

          if(this.peoSectionBarChartData && this.peoSectionBarChartData.length > 0){

            let totalViolations = this.peoSectionBarChartData.reduce(function (acc, obj) { return acc + obj.violationCount; }, 0);

            for (let i = 0; i < this.peoSectionBarChartData.length; i++) {
              let peoPercentage = parseFloat(((this.peoSectionBarChartData[i].violationCount/totalViolations)*100).toString()).toFixed(2);
              if(peoPercentage == "NaN"){
                peoPercentage = "0";
              }
              this.peoSectionProgressBar.push(peoPercentage + "%")
            }
          }
          else{
            this.peoSectionProgressBar = ["0%", "0%", "0%"];
          }

        }
         else{
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      })
    }


    createViolationSectionCircleProgress(){
      let violationData = this.violationSectionBarChartData.data
      this.zoneProgressPercentage = [];

      if(violationData){
        for(let i=0; i<3; i++){
          if(violationData[i] && violationData[i].totalScan){
            this.zoneProgressPercentage.push((violationData[i].violationCount/violationData[i].totalScan)*100);
          }
          else{
            this.zoneProgressPercentage.push(0);
          }
        }
      }

    }

    // setViolationHeatMapTabText(){
    //   this.trafficFlowMapTabList = [];

    //   this.violationSectionBarChartData.data.forEach(element => {
    //     let obj = {
    //       geofenceId: element.geofenceId,
    //       geofenceName: element.geofenceName.substring(0,12),
    //       totalScan: element.totalScan,
    //       violationCount: element.violationCount
    //     }

    //     this.trafficFlowMapTabList.push(obj);
    //   });

    // }






















    createViolationSectionLineChart(){

      if(this.chartLine){
        this.chartLine.destroy();
      }

      let lineChartLable = [];
      let lineChartData = [];

      if(this.selectedTabIndex == 0){
        lineChartLable = ['12AM', '1AM', '2AM','3AM', '4AM', '5AM', '6AM ', '7AM', '8AM', '9AM', '10AM', '11AM',
                          '12PM', '1PM', '2PM','3PM', '4PM', '5PM', '6PM ', '7PM', '8PM', '9PM', '10PM', '11PM']
        this.countViolationForHourly.forEach(violationCount => {
          lineChartData.push(violationCount);
        });
      }
      else{
        this.violationSectionLineChartData.forEach(element => {
          lineChartLable.push(element.month);
          lineChartData.push(element.totalViolation);
        });
      }


      this.chartLine = new Chart("violationSectionLineChart", {
        type: 'line', //this denotes tha type of chart

        data: {// values on X-Axis
          labels: lineChartLable,
          datasets: [
            {
              label: "Violations",
              data: lineChartData,
              borderColor: 'rgba(218,165,32,1)',
              lineTension: 0.5,
              radius: 5,
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true ,
          aspectRatio: 2.5,
          legend: {
            display: true,
            position: 'top',
            labels: {
              fontColor: '#999',
              fontSize: 14,
            },
          },
        }

      });
    }

    createLiveSectionBarChart(){

      if(this.liveSectionBarChart){
        this.liveSectionBarChart.destroy();
      }

      let labels = ['Scans', 'Authorized', 'Permitted', 'Unauthorized', 'Unpaid', 'Expired'];
      let data = [
        this.liveSectionBarChartData.totalScans,
        this.liveSectionBarChartData.totalAuthorized,
        this.liveSectionBarChartData.totalPermitted,
        this.liveSectionBarChartData.totalUnauthorized,
        this.liveSectionBarChartData.totalUnpaid,
        this.liveSectionBarChartData.totalExpired,
      ]

      let dataset = {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Count',
          barThickness: this.barThickness,
          backgroundColor: this.barBackgroundColor,
        }]
      };


      this.liveSectionBarChart = new Chart("liveSectionBarChart", {
        type: 'bar',
        data: dataset,
      });
    }

    createViolationSectionBarChart(){
      if(this.violationSectionBarChart){
        this.violationSectionBarChart.destroy();
      }

      let violationData = this.violationSectionBarChartData.data

      let labels = []
      let data = [];
      violationData.forEach(element => {
        labels.push(element.geofenceName);
        data.push(element.totalScan);
      });

      let dataset = {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Scans',
          barThickness: this.barThickness,
          backgroundColor: this.barBackgroundColor,
        }]
      };

      this.violationSectionBarChart = new Chart("violationSectionBarChart", {
        type: 'bar',
        data: dataset,
      });
    }

    createPeoSectionBarChart(){
      if(this.peoSectionBarChart){
        this.peoSectionBarChart.destroy();
      }

      let violationData = this.violationSectionBarChartData.data

      let labels = []
      let data = [];
      violationData.forEach(element => {
        labels.push(element.geofenceName);
        data.push(element.violationCount);
      });

      let dataset = {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Violations',
          barThickness: this.barThickness,
          backgroundColor: this.barBackgroundColor,
        }]
      };

      this.peoSectionBarChart = new Chart("peoSectionBarChart", {
        type: 'bar',
        data: dataset,
      });
    }

    createRevenueSectionZoneBarChart(){

      if(this.revenueSectionZoneBarChart){
        this.revenueSectionZoneBarChart.destroy();
      }

      let violationData = this.violationSectionBarChartData.data
      this.violationTotalRevenue = 0;

      violationData.forEach(element => {
        element.revenue = element.violationCount * this.revenuePrice;
        this.violationTotalRevenue += element.revenue;
      });

      this.revenueViolationData = violationData;

      var myoption = {
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 1
        },
        animation: {
        duration: 1,
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
                ctx.textAlign = 'center';
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                ctx.textBaseline = 'bottom';

                // Loop through each data in the datasets

                this.data.datasets.forEach(function (dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function (bar, index) {
                        var data = dataset.data[index];
                        ctx.fillText('$ ' + violationData[index].revenue, bar._model.x, bar._model.y - 5);

                    });
                });
            }
        }
      }


      let labels = []
      let data = [];
      violationData.forEach(element => {
        labels.push(element.geofenceName);
        data.push(element.revenue);
      });

      let dataset = {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Revenue By Zone',
          barThickness: this.barThickness,
          backgroundColor: this.barBackgroundColor,
        }]
      };

      this.revenueSectionZoneBarChart = new Chart("revenueSectionZoneBarChart", {
        type: 'bar',
        data: dataset,
        options: myoption
      });
    }

    createRevenueSectionAnalyticsBarChart(){

      if(this.revenueSectionAnalyticsBarChart){
        this.revenueSectionAnalyticsBarChart.destroy();
      }

      let violationData = this.violationDataMonthly;

      violationData.forEach(element => {
        element.revenue = element.totalViolation * this.revenuePrice;
      });

      this.revenueMonthlyViolationData = violationData;

      var myoption = {
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 1
        },
        animation: {
        duration: 1,
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
                ctx.textAlign = 'center';
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                ctx.textBaseline = 'bottom';

                // Loop through each data in the datasets

                this.data.datasets.forEach(function (dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function (bar, index) {
                        var data = dataset.data[index];
                        ctx.fillText('$ ' + violationData[index].revenue, bar._model.x, bar._model.y - 5);

                    });
                });
            }
        }
      }


      let labels = []
      let data = [];
      violationData.forEach(element => {
        labels.push(element.month);
        data.push(element.revenue);
      });

      let dataset = {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Revenue By Month',
          barThickness: this.barThickness,
          backgroundColor: this.barBackgroundColor,
        }]
      };

      this.revenueSectionAnalyticsBarChart = new Chart("revenueSectionAnalyticsBarChart", {
        type: 'bar',
        data: dataset,
        options: myoption
      });
    }

    calculateRevenue(){
      this.createRevenueSectionZoneBarChart();
      this.createRevenueSectionAnalyticsBarChart();
    }














    onMapLoad(mapInstance: google.maps.Map) {

      this.map = mapInstance;

      this.loadHeatmap();

      // here our in other method after you get the coords; but make sure map is loaded

      // const coords: google.maps.LatLng[] = this.getPoints();
      // this.heatmap = new google.maps.visualization.HeatmapLayer({
      //     map: this.map,
      //     data: coords
      // });

    }

    loadHeatmap() {
      // Get new coordinates for heatmap
      const newCoords: google.maps.LatLng[] = this.getPoints();

      // Clear existing heatmap
      if (this.heatmap) {
        this.heatmap.setData([]);
      }

      // Create new heatmap with new data
      this.heatmap = new google.maps.visualization.HeatmapLayer({
        map: this.map,
        data: newCoords,
      });
    }


    getPoints() {
      let coords = [];

      this.selectedGeofenceShiftDetails.forEach(element => {
        let obj = new google.maps.LatLng(element.latitude, element.longitude);
        coords.push(obj);
      });

      return coords;
    }














    setExportData(exportData: any, divElementRef: any, analyticsType: any){
      this.dataForExport = exportData;
      this.analyticsType = analyticsType;
      this.selectedDivElemetRef = divElementRef;


      if(!this.dataForExport){
        this.toastrService.error("No Data Found", "Failed To Export CSV!")
        return;
      }

      this.dataForCsvPdf = [];

      if(this.analyticsType == 'LIVE'){
        this.headerForExport = ['Date', 'Shifts', 'Scans', 'Permitted', 'Authorized', 'Expired', 'Unauthorized', 'Unpaid'];
        let row = this.dataForExport;
        let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized,
                            row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
        this.dataForCsvPdf.push(rowData);
        this.dateRangeForExport = null;
      }

      else if(this.analyticsType == 'Vehicle Location Map'){
        this.dateRangeForExport = null;
        this.headerForExport = ['PEO', 'Latitude', 'Longitude'];
        this.dataForExport.forEach((row: any) => {
          let rowData: any = [row.peoName, row.latitude, row.longitude];
          this.dataForCsvPdf.push(rowData);
        });
      }

      else if(this.analyticsType == 'Violation Trends'){
        this.headerForExport = ['Hour', 'Total Violations'];

        if(this.selectedTabIndex == 1){
          this.headerForExport[0] = 'Date';
        }
        else if(this.selectedTabIndex == 2 || this.selectedTabIndex == 3){
          this.headerForExport[0] = 'Month';
        }

        if(this.selectedTabIndex != 0){
          this.dataForExport.forEach((row: any) => {
            let totalViolation = row.totalExpired + row.totalUnauthorized + row.totalUnpaid;
            let rowData: any = [row.month, totalViolation];
            this.dataForCsvPdf.push(rowData);
          });
        }
        else{
          let hourLable = ['12AM', '1AM', '2AM','3AM', '4AM', '5AM', '6AM ', '7AM', '8AM', '9AM', '10AM', '11AM',
                           '12PM', '1PM', '2PM','3PM', '4PM', '5PM', '6PM ', '7PM', '8PM', '9PM', '10PM', '11PM']

          this.countViolationForHourly.forEach((row: any, index: any) => {
            let rowData: any = [hourLable[index], row];
            this.dataForCsvPdf.push(rowData);
          });
        }

        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Violation Insights'){
        this.headerForExport = ['Unauthorized', 'Unpaid', 'Expired'];
        let row = this.dataForExport;
        let countRow = [row.totalUnauthorized, row.totalUnpaid, row.totalExpired];
        let percentRow = [this.unauthProgressBar, this.unpaidProgressBar, this.expiredProgressBar]

        this.dataForCsvPdf.push(countRow);
        this.dataForCsvPdf.push(percentRow);

        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Hotspot Zones Scans'){
        this.headerForExport = ['Geofence', 'Total Scans', 'Total Violations'];
        this.dataForExport.forEach((row: any) => {
          let rowData: any = [row.geofenceName, row.totalScan, row.violationCount];
          this.dataForCsvPdf.push(rowData);
        })
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Hotspot Zones Violations'){
        this.headerForExport = ['Geofence', 'Total Scans', 'Total Violations', 'Violation Percentage'];
        for (let i = 0; i < 3; i++) {
          let row = this.dataForExport[i];
          let rowData: any = [row.geofenceName, row.totalScan, row.violationCount, this.zoneProgressPercentage[i].toFixed(2)+"%"];
          this.dataForCsvPdf.push(rowData);
        }
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Scanned Violations By PEO'){
        this.headerForExport = ['PEO', 'Violation Percentage'];
        for (let i = 0; i < 3; i++) {
          let rowData: any = [this.peoSectionBarChartData[i].peoName, this.dataForExport[i]];
          this.dataForCsvPdf.push(rowData);
        }
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Scanned Violations By Zone'){
        this.headerForExport = ['Geofence', 'Total Scans', 'Total Violations'];
        this.dataForExport.forEach((row: any) => {
          let rowData: any = [row.geofenceName, row.totalScan, row.violationCount];
          this.dataForCsvPdf.push(rowData);
        })
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Revenue By Zone'){
        this.headerForExport = ['Geofence', 'Total Scans', 'Total Violations', 'Revenue', 'Fine Cost'];
        this.dataForExport.forEach((row: any) => {
          let rowData: any = [row.geofenceName, row.totalScan, row.violationCount, '$' + row.revenue, this.revenuePrice];
          this.dataForCsvPdf.push(rowData);
        })
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }

      else if(this.analyticsType == 'Revenue Analytics'){
        this.headerForExport = ['Month', 'Total Scans', 'Total Violations', 'Revenue', 'Fine Cost'];
        this.dataForExport.forEach((row: any) => {
          let rowData: any = [row.month, row.totalScans, row.totalViolation, '$' + row.revenue, this.revenuePrice];
          this.dataForCsvPdf.push(rowData);
        })
        this.dateRangeForExport = this.selectedDateFilter.start.format("MM-DD-YYYY") + " - " + this.selectedDateFilter.end.format("MM-DD-YYYY");
      }
    }



    exportExcelAll(): void{

      let reportData = {
        title: this.analyticsType + " - " + this.currentOrgData.name,
        data: this.dataForCsvPdf,
        headers: this.headerForExport,
        dateRange: this.dateRangeForExport
      };

      this.excelExportDataService.exportExcel(reportData)
    }



    exportPdfAll(){
      const doc = new jsPDF()

      if(this.dateRangeForExport){
        doc.text(this.dateRangeForExport, 75, 15);
      }
      else{
        doc.text('', 75, 15);
      }

      autoTable(doc, { html: '#my-table' })

      autoTable(doc, {
        head: [this.headerForExport],
        body: this.dataForCsvPdf,
      })

      doc.save(this.analyticsType + " - " + this.currentOrgData.name + '.pdf')
    }























    exportPNG(){
      html2canvas(this.liveSectionCanvas.nativeElement, {backgroundColor: null}).then(canvas => {
        this.canvas.nativeElement.src = canvas.toDataURL();
        this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
        this.downloadLink.nativeElement.download = 'marble-diagram.png';
        this.downloadLink.nativeElement.click();
      });
    }



    onRowClicked(row: any, rowId: any){
      this.heatmapSelectedRowIndex = rowId;
      this.filterShiftDataByGeofence(row.geofenceId);
    }


    getDateWithFormat(date: any, format: any): any {
      return this.datePipe.transform(date, format);
    }
}
